import React from 'react';
const CloseIconSmall = () => {
    return (React.createElement("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M14.2505 4.8075L13.193 3.75L9.00049 7.9425L4.80799 3.75L3.75049 4.8075L7.94299 9L3.75049 13.1925L4.80799 14.25L9.00049 10.0575L13.193 14.25L14.2505 13.1925L10.058 9L14.2505 4.8075Z", fill: "#363948" })));
};
export default CloseIconSmall;
